import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { If } from '~/components';
import {
  FluidTheme,
  Navigate,
  Route,
  Routes as Switch,
  isEmpty,
  useParams,
} from '~/modules';
import {
  CreditSimulationBankAccount,
  CreditSimulationConfirmation,
  CreditSimulationInstallments,
  CreditSimulationIntro,
  CreditSimulationMethod,
  CreditSimulationPixKey,
  CreditSimulationPixKeyConfirmation,
  CreditSimulationSelfie,
  CreditSimulationSuccess,
  CreditSimulationSummary,
  CreditSimulationValue,
  CreditSimulationWithdrawalConfirmation,
  ErrorScene,
  OnboardingAddress,
  OnboardingCep,
  OnboardingConfirmation,
  OnboardingContract,
  OnboardingDocPhotoBack,
  OnboardingDocPhotoFront,
  OnboardingIntro,
  OnboardingPhone,
  OnboardingSelfie,
  OnboardingSignature,
} from '~/scenes';
import { useStores } from '~/utils';
import { Routes } from './routing';

const RoutesContainer: React.FC = () => {
  const {
    theme: { theme },
  } = useStores();
  const [themeVerificated, setThemeVerificated] = useState<FluidTheme>(theme);
  const { id } = useParams();

  useEffect(() => {
    setThemeVerificated(theme);
  }, [theme]);

  return (
    <If condition={!isEmpty(themeVerificated)}>
      <Switch>
        <Route path="/" element={<Navigate to={`/${id}`} />} />
        <Route path="/:id" element={<CreditSimulationIntro />} />
        <Route
          path={Routes.CREDIT_SIMULATION_INTRO}
          element={<CreditSimulationIntro />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_VALUE}
          element={<CreditSimulationValue />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_INSTALLMENTS}
          element={<CreditSimulationInstallments />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_SUMMARY}
          element={<CreditSimulationSummary />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_SELFIE}
          element={<CreditSimulationSelfie />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_METHOD}
          element={<CreditSimulationMethod />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_BANK_ACCOUNT}
          element={<CreditSimulationBankAccount />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_PIX_KEY}
          element={<CreditSimulationPixKey />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_PIX_KEY_CONFIRMATION}
          element={<CreditSimulationPixKeyConfirmation />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_CONFIRMATION}
          element={<CreditSimulationConfirmation />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_WITHDRAWAL_CONFIRMATION}
          element={<CreditSimulationWithdrawalConfirmation />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_SUCCESS}
          element={<CreditSimulationSuccess />}
        />
        <Route path={Routes.ONBOARDING_INTRO} element={<OnboardingIntro />} />
        <Route path={Routes.ONBOARDING_PHONE} element={<OnboardingPhone />} />
        <Route path={Routes.ONBOARDING_CEP} element={<OnboardingCep />} />
        <Route
          path={Routes.ONBOARDING_ADDRESS}
          element={<OnboardingAddress />}
        />
        <Route path={Routes.ONBOARDING_SELFIE} element={<OnboardingSelfie />} />
        <Route
          path={Routes.ONBOARDING_DOC_PHOTO_FRONT}
          element={<OnboardingDocPhotoFront />}
        />
        <Route
          path={Routes.ONBOARDING_DOC_PHOTO_BACK}
          element={<OnboardingDocPhotoBack />}
        />
        <Route
          path={Routes.ONBOARDING_SIGNATURE}
          element={<OnboardingSignature />}
        />
        <Route
          path={Routes.ONBOARDING_CONTRACT}
          element={<OnboardingContract />}
        />
        <Route
          path={Routes.ONBOARDING_CONFIRMATION}
          element={<OnboardingConfirmation />}
        />
        <Route path={Routes.ERROR_SCENE} element={<ErrorScene />} />
        <Route path="*" element={<Navigate to={`/${id}`} />} />
      </Switch>
    </If>
  );
};

export { Routes };
export default observer(RoutesContainer);
